var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import { LocalizationConsumer } from '.';
export default (function (Component) {
  var withLocalization = function withLocalization(props) {
    return React.createElement(LocalizationConsumer, null, function (_ref) {
      var localize = _ref.localize;
      return React.createElement(Component, _extends({}, props, {
        localize: localize
      }));
    });
  };
  withLocalization.displayName = 'withLocalization(' + Component.name + ')';
  return withLocalization;
});